<template>
  <div id="qRootEl" ref="qRootEl" :class="rootClass" v-vpshow>
    <!--div class="title-3">
             Join one of the largest AI communities in the world.
        </div-->
    <div class="wrapper">
      <div class="quantities-section">
        <div>
          <div class="title-1">
            {{ numberFormat(Math.floor(skillsCertifiedTween)) }}
          </div>
          <div class="description-1">
            skills measured
          </div>
        </div>
        <div>
          <div class="title-1">{{ Math.floor(countriesTween) }}+</div>
          <div class="description-1">
            countries
          </div>
        </div>
        <div>
          <div class="title-1">
            {{ numberFormat(Math.floor(recommendationsTween)) }}+
          </div>
          <div class="description-1">
            recommendations to learning resources
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { publicInformationStore } from "~/store";

import tweenMixin from "~/mixins/tweenMixin.js";

export default {
  data() {
    return {
      skillsCertified: 0,
      countries: 0,
      recommendations: 0,
      startLoop: false
    };
  },
  mixins: [
    tweenMixin("recommendations", 1000, pos => pos),
    tweenMixin("skillsCertified", 1000, pos => pos),
    tweenMixin("countries", 1000, pos => pos)
  ],
  computed: {
    rootEl: function() {
      return this.$refs;
    },
    rootClass() {
      if (this.$mq === "desktop") {
        return "quantities-section-wrapper";
      } else {
        return "quantities-section-mobile";
      }
    },
    numberOfSkillsEvaluated() {
      if (process.client) {
        return parseInt(
          localStorage.getItem("evaluatedSkillsCache") ||
            publicInformationStore.skillsEvaluatedCount
        );
      }
      return 123102;
    }
  },
  watch: {
    numberOfSkillsEvaluated(newVal, oldVal) {
      this.skillsCertified = this.numberOfSkillsEvaluated;
    }
  },
  mounted() {
    if (publicInformationStore) {
      publicInformationStore.fetchEvaluatedSkillsCount();
    }

    const _self = this;

    this.observer = new MutationObserver(mutations => {
      for (const m of mutations) {
        const newValue = m.target.getAttribute(m.attributeName);
        this.$nextTick(() => {
          this.onClassChange(newValue, m.oldValue);
        });
      }
    });

    this.observer.observe(this.$refs.qRootEl, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ["class"]
    });
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
  methods: {
    onClassChange(classAttrValue) {
      const classList = classAttrValue.split(" ");
      if (classList.includes("enter")) {
        this.skillsCertified = this.numberOfSkillsEvaluated;
        this.countries = 150;
        this.recommendations = 10000;
        this.randomSkillsAddInterval();
      }
    },
    randomSkillsAddInterval() {
      const _self = this;
      if (!process.client) {
        return 123102;
      }

      function innerLoop() {
        const rand = Math.round(Math.random() * (3000 - 500)) + 500;
        setTimeout(function() {
          if (_self.skillsCertifiedTween === _self.skillsCertified) {
            _self.startLoop = true;
          }
          if (_self.startLoop) {
            _self.skillsCertified = _self.skillsCertified + 1;
            localStorage.setItem(
              "evaluatedSkillsCache",
              _self.skillsCertified.toString()
            );
          }
          innerLoop();
        }, rand);
      }

      innerLoop();
    },
    numberFormat(values) {
      return values.toLocaleString();
    }
  }
};
</script>

<style lang="scss" scoped>
%wrapper {
  background: $primary-yellow;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;

  .quantities-section {
    min-height: 260px;
    align-content: center;

    > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
}

.quantities-section-wrapper {
  @extend %wrapper;

  .title-3 {
    margin: 40px auto;
  }

  .quantities-section {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    max-width: 90%;

    > div {
      padding: 0 2.5rem;
      border-right: 1px solid #002029;
    }

    :last-child {
      border-right: none;
    }
  }
}

.quantities-section-mobile {
  @extend %wrapper;

  .quantities-section {
    grid-template-rows: repeat(3, 1fr);

    margin-top: 2rem;
    margin-bottom: 2rem;

    > div {
      padding: 1rem;
      max-width: 240px;
      margin-top: 1rem;
      margin-bottom: 1rem;
      margin: auto;
      border-bottom: 1px solid #002029;
    }

    :last-child {
      border-bottom: none;
    }
  }
}
</style>
